function renderCustomCarousel1(inputFieldName, containerName, api){
   inputFieldName == undefined || inputFieldName.Similar == null ? $('.similar-products').parent().remove() : '';
    const { Similar:value } = inputFieldName;
    var ProductStyleId = value ? value.replace(/\//g, ' ').trim().split(" ") : '';
  	value && ProductStyleId.sort();
      if(ProductStyleId.length == 0){
          $('.similar-products').parent().remove()
      }
    async function createRelListTplItem(product,rLength,index) {
        var relListCotainer = $('['+containerName+']').find('.products-grid');
        console.log(relListCotainer);
        var productHTML = '',
            price_min = Shopify.formatMoney(product.price_min, window.money_format);
        arraycontainsturtles = (product.tags.indexOf("callforprice") > -1);
        arraycontainsLadiessize = (product.tags.indexOf("Size:LADIES RINGS") > -1);
        arraycontainsMenssize = (product.tags.indexOf("Size:MENS RINGS") > -1);

        var effectImage = product.featured_image;
        if(product.images[3]){
          effectImage = product.images[3];
        }else if(product.images[2]){
          effectImage = product.images[2];
        }

         productHTML += '<div class="product slick-slide">';
        productHTML += '<div class="product-item-6 product-item enable_background_button_card" data-product-id="'+product.handle+'" >';
        productHTML += '<div class="card">';

        productHTML += '<div class="card-product">';
        productHTML += '<div class="card-product__wrapper">';
        productHTML += '<a class="card-media card-media--adapt media--hover-effect" href="'+product.url+'" style="padding-bottom: 100.0%;" tabindex="0"><img data-srcset="'+product.featured_image+' 720w" srcset="'+product.featured_image+' 720w"><img data-srcset="'+effectImage+' 720w"srcset="'+effectImage+' 720w"><span class="data-lazy-loading"></span></a>';
        productHTML += '<div class="card-product__group group-right">';
        productHTML += '<div class="card-product__group-item card-wishlist">';
        productHTML += '<a class="wishlist-icon" href="#" data-wishlist="" data-wishlist-handle="'+product.handle+'" data-product-id="'+product.id+'" tabindex="0">';
        productHTML += '<span class="visually-hidden">Add to wishlist</span>';
        productHTML += '<span class="text"> Add to wishlist </span>';
        productHTML += '<svg viewBox="0 0 512 512" class="icon icon-wishlist"><g><g><path d="M474.644,74.27C449.391,45.616,414.358,29.836,376,29.836c-53.948,0-88.103,32.22-107.255,59.25c-4.969,7.014-9.196,14.047-12.745,20.665c-3.549-6.618-7.775-13.651-12.745-20.665c-19.152-27.03-53.307-59.25-107.255-59.25c-38.358,0-73.391,15.781-98.645,44.435C13.267,101.605,0,138.213,0,177.351c0,42.603,16.633,82.228,52.345,124.7c31.917,37.96,77.834,77.088,131.005,122.397c19.813,16.884,40.302,34.344,62.115,53.429l0.655,0.574c2.828,2.476,6.354,3.713,9.88,3.713s7.052-1.238,9.88-3.713l0.655-0.574c21.813-19.085,42.302-36.544,62.118-53.431c53.168-45.306,99.085-84.434,131.002-122.395C495.367,259.578,512,219.954,512,177.351C512,138.213,498.733,101.605,474.644,74.27z M309.193,401.614c-17.08,14.554-34.658,29.533-53.193,45.646c-18.534-16.111-36.113-31.091-53.196-45.648C98.745,312.939,30,254.358,30,177.351c0-31.83,10.605-61.394,29.862-83.245C79.34,72.007,106.379,59.836,136,59.836c41.129,0,67.716,25.338,82.776,46.594c13.509,19.064,20.558,38.282,22.962,45.659c2.011,6.175,7.768,10.354,14.262,10.354c6.494,0,12.251-4.179,14.262-10.354c2.404-7.377,9.453-26.595,22.962-45.66c15.06-21.255,41.647-46.593,82.776-46.593c29.621,0,56.66,12.171,76.137,34.27C471.395,115.957,482,145.521,482,177.351C482,254.358,413.255,312.939,309.193,401.614z"></path></g></svg>';
        productHTML += '</a></div>';
        // productHTML += '<div class="card-product__group-item card-quickview card-quickviewIcon">';
        // productHTML += '<a class="quickview-icon" href="javascript:void(0)" data-product-id="'+product.id+'" data-open-quick-view-popup="" data-product-handle="'+product.handle+'" tabindex="0">';
        // productHTML += '<span class="visually-hidden">Quick View</span><span class="text"> Quick View </span>';
        // productHTML += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999" aria-hidden="true" focusable="false" role="presentation" class="icon icon-eyes"><path d="M508.745,246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818,239.784,3.249,246.035c-4.332,5.936-4.332,13.987,0,19.923c4.569,6.257,113.557,153.206,252.748,153.206s248.174-146.95,252.748-153.201C513.083,260.028,513.083,251.971,508.745,246.041z M255.997,385.406c-102.529,0-191.33-97.533-217.617-129.418c26.253-31.913,114.868-129.395,217.617-129.395c102.524,0,191.319,97.516,217.617,129.418C447.361,287.923,358.746,385.406,255.997,385.406z"></path><path d="M255.997,154.725c-55.842,0-101.275,45.433-101.275,101.275s45.433,101.275,101.275,101.275s101.275-45.433,101.275-101.275S311.839,154.725,255.997,154.725z M255.997,323.516c-37.23,0-67.516-30.287-67.516-67.516s30.287-67.516,67.516-67.516s67.516,30.287,67.516,67.516S293.227,323.516,255.997,323.516z"></path></svg>';
        // productHTML += '</a></div>';
        productHTML += '</div>';
        productHTML += '<div class="card-action">';
        if (product.price_min == 0) {
            productHTML += '<div> &nbsp; </div>';                      
          } else if ( arraycontainsturtles ) {
            productHTML += '<div> &nbsp; </div>';
          } else {                  
            productHTML += '<form action="/cart/add" method="post" class="variants" id="form-' + product.id +'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';
            if (product.available) {
              if ( arraycontainsLadiessize ){
                productHTML += '<a class="button button-ATC" title="'+product.title+'" href="' + product.url +'">Choose Options</a>';
              }
              else if ( arraycontainsMenssize ){
                productHTML += '<a class="button button-ATC" title="'+product.title+'" href="' + product.url +'">Choose Options</a>';
              }
              else if (product.variants.length == 1) {
                productHTML += '<button data-btn-addToCart class="button button-ATC" data-form-id="#wishlist-product-form-' + product.id +'" data-btn-addToCart type="submit">Add to cart</button><input type="hidden" name="id" value="'+ product.variants[0].id +'" />';
              }
              else {
                productHTML += '<a class="button button-ATC" title="'+product.title+'" href="' + product.url +'">Choose Options</a>';
              }
            } else {
              productHTML += '<button class="button button-ATC" type="submit" disabled="disabled">Out Of Stock</button>';
            }
            productHTML += '</form>';  
          };
        productHTML += '</div></div></div>';
        productHTML += '<div class="card-information">';
        productHTML += '<div class="card-information__wrapper text-center">';
        productHTML += '<div class="card-information__group card-information__group-2">';
        productHTML += '<div class="card-vendor">';
        productHTML += '<a href="' + '/collections/vendors?q='+product.vendor+'" title="'+product.vendor+'">'+product.vendor+'</a>';
        productHTML += '</div></div>';
        productHTML += '<a class="card-title link-underline card-title-ellipsis" href="' + product.url +'" data-product-title="'+product.title+'" data-product-url="' + product.url +'" tabindex="0">'
        productHTML += '<span class="text"> '+product.title+' </span></a>';
        productHTML += '<div class="card-price">';
        productHTML += '<div class="price-regular">';
        productHTML += '<dl>';
        if (product.price_min == 0) {
            productHTML += '<div class="price">';
            productHTML += '<div class="prices">';
            productHTML += '<span class="price-item price-item--regular">Call Store for Price</span></div></div>';
        } else if ( arraycontainsturtles ) {
            productHTML += '<div class="price">';
            productHTML += '<div class="prices">';
            productHTML += '<span class="price-item price-item--regular">Call Store for Price</span></div></div>';
        } else {
            productHTML += '<div class="price__regular">';
            productHTML += '<div class="prices">';
            productHTML += '<span class="price-item price-item--regular">'+ price_min +'</span></div></div>';                
        };
        productHTML += '</dl></div></div></div>';
        productHTML += '</div></div></div></div>';
        
        relListCotainer.append(productHTML);
        var regex = /(<([^>]+)>)/ig;
        var href = $('.wrapper-wishlist a.share').attr("href");
        href += encodeURIComponent( product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
        $('.wrapper-wishlist a.share').attr("href", href );           
    }
    function getRenderData(ProductHandle){
        return new Promise((resolve, reject)=>{
          jQuery.getJSON('/products/'+ProductHandle+'.js',function(){})
          .done(function(product) { return resolve(product)})
		  .fail(function(error) { return reject(error.statusText) });     
        })
      }

    function getHandleData(url){
        return new Promise((resolve, reject)=>{
          fetch(url)
            .then(response => response.json())
            .then((response)=>{
                if(response.data.length > 0){
                    response.data.map(function(element, index){
                      if(element.handle){
                        resolve(element.handle);             
                      }
                    });
                  }  
                 else{
                   resolve(false)
                 }
            })
            .catch((error) => {
              reject(error.statusText)
              //console.error('Error:', error);
            });
        })
      }
    function sliderInit(){
        var featuredProduct = $('['+containerName+']');

            featuredProduct.each(function () {
              var self = $(this),
                  productGrid = self.find('.products-grid'),
                  gridItemWidth = productGrid.data('row'),
                  hasRightSidebar = $('.halo-product-content .pro-page [data-has-right-sidebar]');

              if(productGrid) {
                  productGrid.slick({
                      get vertical() {
                          if(productGrid.hasClass('verticle') && $('.relate-verticle').length) {
                              return this.vertical = true;
                          }else {
                              return this.vertical = false;
                          }
                      },
                     slidesToScroll: 4,
                     slidesToShow: 4,
                                     
                      speed: 1000,
                      infinite: false,
                      centerMode:false, 
                      get dots() {
                          if(self.hasClass('has-banner')) {
                              return this.dots = true;
                          }else {
                              if(window.product_style == 'supermarket' || window.product_style == 'surfup') {
                                  return this.dots = true;
                              } else {
                                  return this.dots = false;
                              }
                          };
                      },
                      get nextArrow() {
                          if ((window.layout_style == 'layout_style_1170') || (window.layout_style == 'layout_style_flower')) {
                              return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                          } else if ((window.layout_style == 'layout_style_fullwidth') || (window.layout_style == 'layout_style_suppermarket') || (window.layout_style == 'layout_style_surfup')) {
                              return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                          }
                          else {
                              return this.nextArrow = '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>';
                          }
                      },
                      get prevArrow() {
                          if ((window.layout_style == 'layout_style_1170') || (window.layout_style == 'layout_style_flower')) {
                              return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                          } else if ((window.layout_style == 'layout_style_fullwidth') || (window.layout_style == 'layout_style_suppermarket') || (window.layout_style == 'layout_style_surfup')) {
                              return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                          } 
                          else {
                              return this.prevArrow = '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>';
                          }
                      },
					  responsive: [
                              {
                                  breakpoint: 1400,
                                  settings: {
                                      get slidesToShow() {
                                          if(self.hasClass('has-banner')) {
                                              return this.slidesToShow = 3;
                                          }else {
                                              if(gridItemWidth > 5) {
                                                  return this.slidesToShow = 5;
                                              }
                                              else {
                                                  if(window.product_style == 'supermarket' || window.product_style == 'surfup') {
                                                      return this.slidesToShow = 4;
                                                  } else {
                                                      return this.slidesToShow = 4;
                                                  }
                                              }
                                          }
                                      },
                                      get slidesToScroll() {
                                          if (self.hasClass('has-banner')) {
                                              return this.slidesToScroll = 3;
                                          }else {
                                              if(productGrid.hasClass('verticle')) {
                                                  return this.slidesToScroll = 1;
                                              }else {
                                                  if(gridItemWidth >= 4) {
                                                      return this.slidesToScroll = 4;
                                                  }else if(gridItemWidth = 3) {
                                                      return this.slidesToScroll = 3;
                                                  }else {
                                                      return this.slidesToScroll = 2;
                                                  }
                                              }
                                          };
                                      }
                                  }
                              },
                              {
                                  breakpoint: 1200,
                                  settings: {
                                      dots: true,
                                      arrows: false,
                                      vertical: false,
                                      get slidesToShow() {
                                          if(self.hasClass('has-banner')) {
                                              return this.slidesToShow = 2;
                                          }else {
                                              if(gridItemWidth >= 4) {
                                                  return this.slidesToShow = 4;
                                              }else if(gridItemWidth = 3) {
                                                  return this.slidesToShow = 3
                                              }else {
                                                  return this.slidesToShow = 2
                                              }
                                          }
                                      },
                                      get slidesToScroll() {
                                          if (self.hasClass('has-banner')) {
                                              return this.slidesToScroll = 2;
                                          }else {
                                              if(gridItemWidth >= 4) {
                                                  return this.slidesToScroll = 4;
                                              }else if(gridItemWidth = 3) {
                                                  return this.slidesToScroll = 3
                                              }else {
                                                  return this.slidesToScroll = 2
                                              }
                                          };
                                      }
                                  }
                              },
                              {
                                  breakpoint: 992,
                                  settings: {
                                      dots: true,
                                      arrows: false,
                                      vertical: false,
                                      get slidesToShow() {
                                          if(gridItemWidth >= 3) {
                                              return this.slidesToShow = 3;
                                          }else {
                                              return this.slidesToShow = 2
                                          }
                                      },
                                      get slidesToScroll() {
                                          if(gridItemWidth >= 3) {
                                              return this.slidesToScroll = 3;
                                          }else {
                                              return this.slidesToScroll = 2
                                          }
                                      }
                                  }
                              },
                              {
                                  breakpoint: 768,
                                  settings: {
                                      slidesToShow: 2,
                                      slidesToScroll: 2,
                                      arrows: false,
                                      vertical: false,
                                      dots: true
                                  }
                              }
                          ]
                  });
              };
            });
    };

    async function loadProducts(){
      
        //Url for getting handle
      	var base_url = "https://rapi.avalonsolution.com/api/ShopifyData?customerid=DREAMJEWELERS&itemcd=";
      
		//Store both Promise In this array        
        let productHandlePromiseArray = [];
      	let productDataPromiseArray = [];
           
      	//Gettin all Product handle value by this loop
        for(let i=0; ProductStyleId.length > i; i++){
            let URL = base_url+ProductStyleId[i];
            productHandlePromiseArray.push(getHandleData(URL));      
        }
          
		// Promise for Product Handle 
        await Promise.allSettled(productHandlePromiseArray)
        .then((productHandleArray)=>{
          productHandleArray.forEach(function({value:handleValue}){
              if(handleValue){
                productDataPromiseArray.push(getRenderData(handleValue));
              }              
          	})   
        });
        // Promise for Product Data
        await Promise.allSettled(productDataPromiseArray)
        .then((productDataArray)=>{
          productDataArray.forEach(function({value:productData},indexNo){
             // console.log(productData);
             productData == undefined ? $('.similar-products').parent().remove() : '';
            if(productData){
              $('['+containerName+']').show();
              createRelListTplItem(productData,productDataArray.length,indexNo);
            }
              
          })
        });
        
      	 sliderInit();
    }
  
  	return loadProducts();
}
(function(){
  var customerID = "DREAMJEWELERS";
  var userName = "Dreamjewelers";
  var userPassword = "Dreamjewelers@12345";
  const skuId = document.querySelector('input[name="products-sku"]').value;
  getProductInfo(skuId, customerID, userName, userPassword).then((productInfo)=>{
   // console.log(productInfo + 'test')
    
    if(productInfo)
      return Object.keys(productInfo).filter((key) => (key=='Similar')).reduce((cur, key) => { return Object.assign(cur, { [key]: productInfo[key] })}, {});  
  }).then((inputFieldName)=>{
    renderCustomCarousel1(inputFieldName, 'data-similar-container', 'https://rapi.avalonsolution.com/api/ShopifyData?customerid=DREAMJEWELERS&itemcd=');   
  });
})();
  
  